import { Moment } from 'moment';
import numeral from 'numeral';
import { ChatGroupId } from '@/chat/models/ChatGroup';
import i18n from '@/general/i18n';
import { WorkshopTeamId } from '@/general/models/WorkshopTeam';
import ReferenceService from '@/general/services/ReferenceService';
import User, { UserId } from '../models/User';
import { formatRelativeDateTime } from './dateTime';
import { Nullish } from './typescript';

export function formatNumber(value: any): string {
  if (!value) return '0';
  return Number(value).toLocaleString(i18n.global.locale.value);
}

export function formatAmount(value: any, naked?: boolean): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '';
  const amount = numeral(value).format('0,0.00');
  return  naked ? amount : `${i18n.global.t('general.currencySymbol')} ${amount}`;
}

export function formatPercentage(value: any): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '';
  return value * 100 + '%';
}

export function formatMileage(value: any): string {
  let result = formatNumber(value);
  if (result) result += ` ${i18n.global.t('general.longDistanceUnit')}`;
  return result;
}

export function formatCreationInfo(entity: Nullish<{ createdBy: Nullish<User>, createdOn: Nullish<Moment> }>): string {
  if (!entity?.createdBy || !entity?.createdOn) return '';
  const user = entity.createdBy.fullName;
  const time = formatRelativeDateTime(entity.createdOn);
  return i18n.global.t('general.creationInfo', { user, time });
}

export function formatModificationInfo(entity: Nullish<{ modifiedBy: Nullish<User>, modifiedOn: Nullish<Moment> }>): string {
  if (!entity?.modifiedBy || !entity?.modifiedOn) return '';
  const user = entity.modifiedBy.fullName;
  const time = formatRelativeDateTime(entity.modifiedOn);
  return i18n.global.t('general.modificationInfo', { user, time });
}

export function displayUser(id: Nullish<UserId>): string {
  return ReferenceService.getUser(id)?.fullName ?? '';
}

export function displayChatGroup(id: Nullish<ChatGroupId>): string {
  return ReferenceService.getChatGroup(id)?.name ?? '';
}

export function displayWorkshopTeam(id: Nullish<WorkshopTeamId>): string {
  return ReferenceService.getWorkshopTeam(id)?.description ?? '';
}
